import { useRef, useState } from "react";
import { motion } from "framer-motion";

// Magnetic hover button — follows the cursor slightly, snaps back on leave.
export const MagneticButton = ({
  children,
  onClick,
  className = "",
  strength = 0.4,
  testId,
  type = "button",
}) => {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const handleMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const x = (e.clientX - (rect.left + rect.width / 2)) * strength;
    const y = (e.clientY - (rect.top + rect.height / 2)) * strength;
    setPos({ x, y });
  };

  return (
    <motion.button
      ref={ref}
      type={type}
      data-testid={testId}
      onClick={onClick}
      onMouseMove={handleMove}
      onMouseLeave={() => setPos({ x: 0, y: 0 })}
      animate={{ x: pos.x, y: pos.y }}
      transition={{ type: "spring", stiffness: 200, damping: 15, mass: 0.4 }}
      className={className}
    >
      {children}
    </motion.button>
  );
};

export default MagneticButton;
